import { __assign } from "tslib";
// DS: I121
import React from 'react';
import IconWrap from '../../IconWrap';
import { useFlag } from '../../../redux/flags/hooks';
var File = function (props) {
    return useFlag('action_icons_update3') ? (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M19 20a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1h9.429L19 7v13zM13 5H7v14h10v-9h-3a1 1 0 01-1-1V5z" })))) : (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { fillRule: "nonzero", fill: "none" },
                React.createElement("path", { fill: "#00E59B", d: "M17.565 5.483H20V21H6V3h11.565z" }),
                React.createElement("path", { fill: "#D1FFF0", d: "M18.391 4v.62H19V22H5V4z" }),
                React.createElement("path", { fill: "#00E59B", d: "M16.875 4h1.875v1.25H20V9h-5V4z" })))));
};
File.displayName = 'File';
export default File;
//# sourceMappingURL=File.js.map